/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BlogPostCard_post = {
    readonly title: string;
    readonly publicationDate: string | null;
    readonly slug: string;
    readonly coverImage: string | null;
    readonly " $refType": "BlogPostCard_post";
};
export type BlogPostCard_post$data = BlogPostCard_post;
export type BlogPostCard_post$key = {
    readonly " $data"?: BlogPostCard_post$data;
    readonly " $fragmentRefs": FragmentRefs<"BlogPostCard_post">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BlogPostCard_post",
  "type": "BlogPost",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "publicationDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "slug",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "coverImage",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '98a46b672ddad37e4fcc895df1a1cf70';
export default node;
